import type { InputHTMLAttributes } from "react";

import { cn } from "../../lib/cn";

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
	label?: string;
	error?: string;
};

export function Input({ label, error, className, id, ...props }: InputProps) {
	const inputId = id ?? (label ? label.toLowerCase().replace(/\s+/g, "-") : undefined);

	return (
		<div className="flex flex-col gap-1.5">
			{label && (
				<label htmlFor={inputId} className="text-sm font-medium text-pastel-black">
					{label}
				</label>
			)}
			<input
				id={inputId}
				className={cn(
					"w-full rounded-lg border bg-white px-3 py-2 text-sm text-pastel-black placeholder:text-pastel-gray",
					"focus:outline-none focus:ring-2 focus:ring-pastel-vibrant-blue/40 focus:border-pastel-vibrant-blue",
					"transition-colors",
					error ? "border-red-400" : "border-pastel-border",
					className
				)}
				{...props}
			/>
			{error && <p className="text-xs text-red-500">{error}</p>}
		</div>
	);
}
